import {projectNameLower} from '../util/pluralizeUtils'
import {concatStr, escapeHtmlSymbols, stringComparator} from '../atUtils'
import HierarchySelectorSelectionHelper from '../controls/selectorControls/selectionHelpers/at_hierarchy_selector_selection_helper'

const SimpleCustomersAndProjectsSelectionHelper = Ext.extend(HierarchySelectorSelectionHelper, {
    pleaseSelectMessageKey: "projects_customers_selector.no_customers_projects_selected",
    withArchivedProjectsKey: "projects_customers_selector.with_all_archived_projects",
    withAllProjectsKey: "projects_customers_selector.with_all_projects",
    withActiveProjectsKey: "projects_customers_selector.with_all_active_projects",
    filteredPrefix: "_filtered",

    isCustomersProjectsFiltered: false,

    getPossibleFilteredKey: function(key) {
        return (this.isCustomersProjectsFiltered) ? key + this.filteredPrefix : key;
    },

    getDescription: function(selection, dropdownButtonId) {
        var customers = selection.getFirstLevel();
        var projects = selection.getSecondLevel();
        if ((customers.length == 0) && (projects.length == 0)) {
            return this.getMessage(this.pleaseSelectMessageKey);
        } else if ((customers.length + projects.length) == 1) {
            var isSingleCustomerSelected = (customers.length == 1);
            return this.getSingleItemText((isSingleCustomerSelected ? customers : projects)[0], isSingleCustomerSelected);
        } else {
            return this.getShortDescriptionForCustomersAndProjects(customers, projects, dropdownButtonId);
        }
    },

    getSingleItemText: function (item, isCustomer) {
        var text = (isCustomer) ? escapeHtmlSymbols(SystemSettings.firstLevelNamingSingular.toLowerCase()) : escapeHtmlSymbols(SystemSettings.secondLevelNamingSingular.toLowerCase());
        text += " ";
        text += escapeHtmlSymbols(item.name);

        if (item.archived) {
            text += " " + this.getMessage(this.inactiveSingleItemTextKey);
        }

        return text;
    },

    getShortDescriptionForCustomersAndProjects: function(customers, projects, dropdownButtonId) {
        var result = "";
        var isCustomersPresent = (customers.length != 0);
        var isProjectsPresent = (projects.length != 0);

        if (!isCustomersPresent && !isProjectsPresent) {
            return this.getMessage(this.pleaseSelectMessageKey);
        }

        if (isCustomersPresent) {
            result += customers.length + " ";
            result += (customers.length == 1) ? escapeHtmlSymbols(SystemSettings.firstLevelNamingSingular.toLowerCase()) : escapeHtmlSymbols(SystemSettings.firstLevelNamingPlural.toLowerCase());
            result += " ";
            result += this.getMessage(this.getPossibleFilteredKey(this.withAllProjectsKey));
            if (isProjectsPresent) {
                if (dropdownButtonId) {
                    result = this.wrapTextByTitleSpans(result, dropdownButtonId, true);
                }
                result += " & ";
            }
        }
        if (isProjectsPresent) {
            var subResult = projects.length + " " + escapeHtmlSymbols(projectNameLower(projects.length));

            if (dropdownButtonId && isCustomersPresent) {
                subResult = this.wrapTextByTitleSpans(subResult, dropdownButtonId, false);
            }
            result += subResult;
        }
        return result;
    },

    getCertainEntityList: function(selection, isForCustomer) {
        var context = this;
        if (isForCustomer) {
            return this.getListDescription(selection.getFirstLevel(), function(item) {return context.getListDescriptionItemForEntity(item)},
                                           function(a, b) {return stringComparator(a.name, b.name)}, SystemSettings.firstLevelNamingPlural.toLowerCase());
        } else {
            return this.getListDescription(selection.getSecondLevel(), function(item) {return context.getListDescriptionItemForEntity(item)},
                                           function(a, b) {return stringComparator(a.name, b.name)}, SystemSettings.secondLevelNamingPlural.toLowerCase());
        }
    },

    getListDescriptionItemForEntity: function(entity) {
        return concatStr(entity.name, this.getListDescriptionItemStatus( entity ), " ");
    },

    getListDescriptionItemStatus : function ( entity ) {
        if(entity.archived) {
            return this.getMessage(this.inactiveSingleItemTextKey);
        }
    }
});

export default SimpleCustomersAndProjectsSelectionHelper


// WEBPACK FOOTER //
// ./web/js/cp_selector/simple_customers_and_projects_selection_helper.js